var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isPublic && _vm.currentClass != 'PublicDashboard')?[_c('auth-layout')]:[(_vm.loggedIn)?[_c('dashboard-layout')]:[_c('auth-layout')]]],2)}
var staticRenderFns = []

export { render, staticRenderFns }